module.exports = __webpack_public_path__ + "img/business-startup.84c2bc02.png";